<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.code }}</strong>
                </CCardHeader>
                <CCardBody>
                    <PromocodeTabLinks />
                    <PromocodeCard :entity="entity" />
                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        @click="$router.push(`/promocodes`)"
                    >Назад</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import PromocodeTabLinks from '@/components/promocodes/PromocodeTabLinks';
    import PromocodeCard from '@/components/promocodes/PromocodeCard';

    export default {
        name: 'Promocode',

        components: {
            PromocodeTabLinks,
            PromocodeCard,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/promocodes/${id}`)).data;
            },
        },
    };
</script>
